import { Link } from "react-router-dom";
import { Instagram, Phone, MapPin } from "lucide-react";
import { BUSINESS, whatsappLink } from "../../data/site";

const Footer = () => (
  <footer
    data-testid="site-footer"
    className="bg-ink text-bone"
  >
    <div className="saree-border-gold" aria-hidden="true" />
    <div className="mx-auto max-w-[1400px] px-5 py-16 sm:px-8 lg:px-12">
      <Link
        to="/contact"
        className="block font-display text-[15vw] leading-[0.85] tracking-tight transition-colors duration-500 hover:text-henna lg:text-[13vw]"
        data-testid="footer-cta"
      >
        Let's talk
      </Link>

      <div className="mt-16 grid gap-10 border-t border-bone/15 pt-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <p className="font-display text-3xl">{BUSINESS.name}</p>
          <p className="mt-3 max-w-sm text-sm leading-relaxed text-bone/60">
            {BUSINESS.tagline}. Serving brides and families across Pathankot and
            Punjab since {BUSINESS.established}.
          </p>
        </div>

        <div>
          <p className="mb-4 text-xs uppercase tracking-[0.2em] text-bone/40">
            Visit
          </p>
          <p className="flex items-start gap-2 text-sm text-bone/80">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
            {BUSINESS.address}
          </p>
          <p className="mt-3 text-sm text-bone/60">{BUSINESS.hours}</p>
        </div>

        <div>
          <p className="mb-4 text-xs uppercase tracking-[0.2em] text-bone/40">
            Connect
          </p>
          <a
            href={`tel:+${BUSINESS.phone}`}
            className="flex items-center gap-2 text-sm text-bone/80 hover:text-gold"
            data-testid="footer-phone"
          >
            <Phone className="h-4 w-4 text-gold" /> {BUSINESS.phoneDisplay}
          </a>
          <a
            href={BUSINESS.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 flex items-center gap-2 text-sm text-bone/80 hover:text-gold"
            data-testid="footer-instagram"
          >
            <Instagram className="h-4 w-4 text-gold" /> {BUSINESS.instagramHandle}
          </a>
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-block rounded-full border border-bone/30 px-5 py-2 text-xs uppercase tracking-[0.18em] hover:bg-bone hover:text-ink"
            data-testid="footer-whatsapp"
          >
            WhatsApp
          </a>
        </div>
      </div>

      <div className="mt-12 flex flex-col justify-between gap-2 border-t border-bone/15 pt-6 text-xs text-bone/40 sm:flex-row">
        <span>
          © {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.
        </span>
        <span>Rated {BUSINESS.rating}★ · {BUSINESS.reviews} reviews</span>
      </div>
    </div>
  </footer>
);

export default Footer;
